<template>
  <div id="app" class="">
    <vue-progress-bar></vue-progress-bar>
    <router-view />
  </div>
</template>

<script>
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify'
import { mapActions } from 'vuex'

export default {
  name: 'home',

  data() {
    return {
      menuBottom: []
    }
  },
  methods: {
    ...mapActions('user', ['getMyDetails']),
    forceSWupdate() {
      if ("serviceWorker" in navigator) {
        console.log("update")
        navigator.serviceWorker
          .getRegistrations()
          .then(function(registrations) {
            for (let registration of registrations) {
              registration.update();
            }
          });
      }
    },
  },
  mounted() {
    this.forceSWupdate()
  },
  beforeCreate() {
    if (['cn', 'ar'].includes(localStorage.getItem('locale'))) {
      let file = document.createElement('link')
      file.rel = 'stylesheet'
      file.href = '/bulma-rtl.css'
      document.head.appendChild(file)
    }

    let self = this
    document.documentElement.classList.add('has-navbar-fixed-top')
    const hostname = window.location.hostname
    if (
      [
        'app.neolicitador.com',
        'app.newfranquicia.com',
        'app.myneofintech.com'
      ].includes(hostname)
    ) {
      self.$store.commit('SET_HOST', hostname.split('.')[1])
    }

    AmplifyEventBus.$on('authState', info => {
      if (info == 'signedOut') {
        self.$store.commit('user/UNSET_USER')
        self.$router.push({ name: 'sign-in' })
      }
      if (info == 'signedIn') {
        Auth.currentAuthenticatedUser()
          .then(() => {
            self.getMyDetails().then(userData => {
              self.$store.commit('user/SET_DEFAULT', userData)
              const nextRoute = self.$store.getters.nextRoute
              if (nextRoute) {
                self.$store.commit('UNSET_NEXT_ROUTE')
                self.$router.push(nextRoute)
              } else {
                if (userData.rol == 'client') {
                  self.$router.push({
                    name: 'onBoard.neofintech.Dashboard'
                  })
                } else {
                  self.$router.push({ name: 'admin.dashboard' })
                }
              }
            })
          })
          .catch(() => (this.signedIn = false))
      }
    })
  }
}
</script>
<style lang="scss">
@import '~@/scss/_mixins.scss';
</style>

<style lang="scss">
#app {
  height: calc(100vh - 60px);
  width: 100%;
  > div {
    height: 100%;
  }
}

.loading-overlay.is-active.is-full-page {
  width: 100% !important;
  height: 100% !important;
  margin: 0 !important;
}

.toast.error {
  background: red;
}

.toast.success {
  background: green;
}

.calendly-badge-widget {
  display: none !important;
}
</style>
